import React from "react";
import styles from "./InvoicePDF.module.css";

const InvoicePDF = ({ data }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const totalTaxableAmountData =
    data.invoice_order_items &&
    data.invoice_order_items?.reduce(
      (acc, item) =>
        acc + parseFloat(item?.unit_rate) * parseFloat(item?.invoice_qty),
      0
    );

  const totalAmountData =
    data.invoice_order_items &&
    data.invoice_order_items?.reduce(
      (acc, item) => acc + parseFloat(item?.amount),
      0
    );

  const formatNumberWithBreaks = (num, isCurrency = false) => {
    if (!num && num !== 0) return "-";
    const options = isCurrency
      ? {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      : {};
    return parseFloat(num)
      .toLocaleString("en-IN", options)
      .replace(/,/g, ",\u200B");
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.header}>
        <div className={styles.logoSection}>
          <img
            src="https://bermadimsapi.disctesting.in/uploads/logo/8e08ec4e6348fc2fe1f64ae147db7496.jpeg"
            alt="BERMAD"
            className={styles.logo}
          />
          <div className={styles.companyName}>
            BERMAD INDIA Private Limited.
          </div>
        </div>
        <div className={styles.addressRight}>
          <h2 className={styles.orderTitle}>Invoice Details</h2>
          <div>
            <strong>Project Name:</strong> {data?.project?.project_name || "-"}
          </div>
          <div>
            <strong>Project Code:</strong> {data?.project?.project_code || "-"}
          </div>
        </div>
      </div>

      <div className={styles.blueBar}></div>

      <table className={styles.orderHeader}>
        <tbody>
          <tr>
            <th style={{ width: "25%", textAlign: "left" }}>Invoice no:</th>
            <th style={{ width: "25%", textAlign: "left" }}>Invoice Date:</th>
            <th style={{ width: "30%", textAlign: "left" }}>SO No:</th>
            <th style={{ width: "20%", textAlign: "left" }}>Order Date:</th>
          </tr>
          <tr>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {data?.invoice_no || "-"}
            </td>
            <td className={styles.cellNowrap} style={{ textAlign: "left" }}>
              {formatDate(data?.createdAt) || "-"}
            </td>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {data?.order?.order_no || "-"}
            </td>
            <td className={styles.cellNowrap} style={{ textAlign: "left" }}>
              {formatDate(data?.order?.order_date) || "-"}
            </td>
          </tr>
        </tbody>
      </table>

      <table className={styles.addressTable}>
        <thead>
          <tr>
            <th className={styles.addressHeader}>Bill To:</th>
            <th className={styles.addressHeader}>Ship To:</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={styles.addressCell}>
              <div className={styles.addressContent}>
                {data?.order?.billing_address}
              </div>
            </td>
            <td className={styles.addressCell}>
              <div className={styles.addressContent}>
                {data?.order?.shipping_address}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <table className={styles.termsTable}>
        <thead>
          <tr>
            <th>Warehouse</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{data?.warehouse?.warehouse_name || "-"}</td>
            <td>{data?.status?.split("_").join(" ").toUpperCase() || "-"}</td>
          </tr>
        </tbody>
      </table>

      <table className={styles.termsTable} style={{ marginTop: "10px" }}>
        <thead>
          <tr>
            <th>Remark:</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{data?.remark || "-"}</td>
          </tr>
        </tbody>
      </table>

      <table className={styles.catalogTable}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr No.</th>
            <th style={{ width: "20%" }}>Item Code</th>
            <th style={{ width: "25%" }}>Customer Desc</th>
            <th style={{ width: "15%" }}>UOM</th>
            <th style={{ width: "10%" }}>Order QTY</th>
            <th style={{ width: "10%" }}>Invoice QTY</th>
            <th style={{ width: "12%" }}>Unit Price</th>
            <th style={{ width: "8%" }}>GST %</th>
            <th style={{ width: "12%" }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {data.invoice_order_items?.length > 0 ? (
            data.invoice_order_items.map((row, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td className={styles.textCenter}>{index + 1}</td>
                  <td>
                    <div className={styles.itemDescription}>
                      <div className={styles.itemCode}>
                        {row?.item?.item_code || "N/A"}
                      </div>
                      <div className={styles.itemDesc}>
                        <span>Product Description:</span>
                        <br />
                        {row?.item?.description || "N/A"}
                      </div>
                    </div>
                  </td>
                  <td className={styles.cellWrap}>
                    {row?.customer_desc || "N/A"}
                  </td>
                  <td className={styles.textCenter}>
                    {row?.item?.uom?.uom_name || "N/A"}
                  </td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {formatNumberWithBreaks(row?.order_qty)}
                    </div>
                  </td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {formatNumberWithBreaks(row?.invoice_qty)}
                    </div>
                  </td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {formatNumberWithBreaks(row?.unit_rate, true)}
                    </div>
                  </td>
                  <td className={styles.textCenter}>
                    <div className={styles.numberWrapper}>
                      {row?.gst_percentage || "0"}
                    </div>
                  </td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {formatNumberWithBreaks(row?.amount, true)}
                    </div>
                  </td>
                </tr>
                {row?.buy_item_details
                  .filter(
                    (child) =>
                      child?.item?.item_code || child?.item_details?.item_code
                  )
                  ?.map((child, childIndex) => (
                    <tr
                      key={`${index}.${childIndex}`}
                      className={styles.subItemRow}
                    >
                      <td
                        className={`${styles.textCenter} ${styles.subItemIndex}`}
                      >{`${index + 1}.${childIndex + 1}`}</td>
                      <td>
                        <div className={styles.subItemCode}>
                          {child?.item?.item_code || child?.item_code || "N/A"}
                          <div className={styles.subItemDesc}>
                            <span>Product Description:</span>
                            <br />
                            {child?.item_desc || "N/A"}
                          </div>
                        </div>
                      </td>
                      <td>-</td>
                      <td className={styles.textCenter}>
                        {child?.item_details?.uom || "N/A"}
                      </td>
                      <td className={styles.textRight}>
                        <div className={styles.numberWrapper}>
                          {formatNumberWithBreaks(child?.qty)}
                        </div>
                      </td>
                      <td className={styles.textRight}>-</td>
                      <td className={styles.textRight}>-</td>
                      <td className={styles.textRight}>-</td>
                      <td className={styles.textRight}>-</td>
                    </tr>
                  ))}
              </React.Fragment>
            ))
          ) : (
            <tr>
              <td colSpan="9" className={styles.textCenter}>
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div className={styles.totalsSectionRight}>
        <table className={styles.totalsTable}>
          <tbody>
            <tr>
              <td className={styles.totalLabel}>TAXABLE AMOUNT:</td>
              <td className={styles.totalValue}>
                <div className={styles.scientificNumber}>
                  {totalTaxableAmountData
                    ? totalTaxableAmountData.toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0.00"}
                </div>
              </td>
            </tr>
            <tr>
              <td className={styles.totalLabel}>GST AMOUNT:</td>
              <td className={styles.totalValue}>
                <div className={styles.scientificNumber}>
                  {totalAmountData - totalTaxableAmountData
                    ? (totalAmountData - totalTaxableAmountData).toLocaleString(
                        "en-IN",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )
                    : "0.00"}
                </div>
              </td>
            </tr>
            <tr className={styles.grandTotal}>
              <td className={styles.totalLabel}>TOTAL AMOUNT:</td>
              <td className={styles.totalValue}>
                <div className={styles.scientificNumber}>
                  {totalAmountData
                    ? totalAmountData.toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0.00"}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles.clearFix}></div>
    </div>
  );
};

export default InvoicePDF;
